__webpack_require__.p = "/Artificial-Intelligence-Application-Laboratory-Website/";